import { useWorkflowTypeMaster } from '../presentations/views/WorkflowTypeMasterConfig/queries';
import React from 'react';
import { TypeMaster } from '../models/type/TypeMaster';

export type WithWorkflowTypeMasterProps = {
    workflowTypeMaster?: TypeMaster[];
};

export function withWorkflowTypeMaster<T extends WithWorkflowTypeMasterProps>(
    WrappedComponent: React.ComponentType<T>
) {
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || 'Component';

    const ComponentWithWorkflowTypeMaster = (
        props: Omit<T, keyof WithWorkflowTypeMasterProps>
    ) => {
        const { data: workflowTypeMaster } = useWorkflowTypeMaster();

        return (
            <WrappedComponent
                workflowTypeMaster={workflowTypeMaster}
                {...(props as T)}
            />
        );
    };

    ComponentWithWorkflowTypeMaster.displayName = `withWorkflowTypeMaster(${displayName})`;

    return ComponentWithWorkflowTypeMaster;
}
